import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DiscrepancySearchField from "@tKgpco/Widgets/DiscrepancyHistory/DiscrepancySearchField";
import * as React from "react";

export const discrepancyIdStyles: SearchTextFieldStyles = {};
const styles = discrepancyIdStyles;

const DiscrepanySearchFieldNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <DiscrepancySearchField
            styles={styles}
            parameterField="discrepancyId"
            label="Discrepancy #"
            inputType="text"
            placeholder=""
            testSelector="discrepancy_filterDiscrepancyId"
        />
    );
};

const widgetModule: WidgetModule = {
    component: DiscrepanySearchFieldNumber,
    definition: {
        group: "Common",
        displayName: "Discrepancy Id Search",
    },
};

export default widgetModule;
